import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import UsuarioService from "./usuarioService"
import FormList from 'base/FormList'

export default function UsuarioList() {

    const [service] = useState(() => new UsuarioService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_usu',
        dsName: 'nome_razao_pes',
        mainField: { name: 'nome_razao_pes', label: 'Nome' },
        advFields: [
            { name: 'codigo_usu', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'login_usu', label: 'Login', type: 'string', inputMode: 'text' },
            { name: 'nome_razao_pes', label: 'Nome', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="meta.nome_razao_pes" sortable header="Nome"></Column>
            <Column field="login_usu" sortable header="Login"></Column>
        </FormList >
    )
}
